import { StyleSheet, Platform } from "react-native";

const styles = StyleSheet.create({
  container: {
    alignSelf: "center",
    width: 350,
    marginTop: 20,
    borderRadius: 8,
    padding: 24,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 4,
    },
    shadowOpacity: 0.25,
    shadowRadius: 4.84,
    elevation: 4,
  },

  cardTitle: {
    paddingTop: 15,
    paddingBottom: 15,
    fontWeight: "bold",
    textAlign: "center",
    fontSize: 16,
    color: "#077A97",
    textTransform: "uppercase",
  },

  contentBtn: {
    alignSelf: "center",
    Width: 350,
    marginTop: 12,
    marginBottom: 10,
  },

  btn: {
    marginTop: 12,
    alignSelf: "center",
    minWidth: 300,
    backgroundColor: "#077A97",
    padding: 10,
    borderRadius: 4,
  },
  textBtn: {
    textTransform: "uppercase",
    color: "#fff",
    justifyContent: "center",
    textAlign: "center",
    fontSize: 18,
    fontWeight: "500",
    color: "#fff",
  },
  label: {
    fontWeight: "bold",
    fontSize: 14,
    marginBottom: 10,
    marginTop: 20,
  },
  input: {
    paddingLeft: 4,
    width: "90%",
    borderRadius: 4,
    lineHeight: 35,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 4.84,
    elevation: 4,
  },
});

export default styles;
